module.exports = __webpack_public_path__ + "static/media/Group 674.bb9f7669.svg";